import { render, staticRenderFns } from "./CtablaFinanciera.vue?vue&type=template&id=2d8a60ae&"
import script from "./CtablaFinanciera.vue?vue&type=script&lang=js&"
export * from "./CtablaFinanciera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports